import React from 'react';
import { LinkedinIcon, MailIcon, MapPinIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { ContactForm } from '../components/ContactForm';
import { profile } from '../data/site';
export function Contact() {
  return <>
      <PageHeader eyebrow="Contact" title="Partner with Dr. Zinkel" description="Open to board seats, venture advising, and strategic consulting opportunities." data-id="element-129" data-mp="1qn0exzz2uni0" />

      <section className="w-full bg-ivory py-20 lg:py-24" data-id="element-130" data-mp="xykzxdfy456o">
        <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10" data-id="element-131" data-mp="t2xe980o9u5x">
          <div className="lg:col-span-5" data-id="element-132" data-mp="17rk1dvwjjq7p">
            <h2 className="font-display text-xl text-ink-950" data-id="element-133" data-mp="17sbpklnt6lny">
              Inquiry Details
            </h2>
            <ul className="mt-8 space-y-4 border-t border-stone pt-8" data-id="element-134" data-mp="fa7rv2h8en8a">
              <li className="flex items-start gap-3 text-sm text-graphite" data-id="element-135" data-mp="f8d7bp9vgx4q">
                <MapPinIcon size={16} className="mt-0.5 shrink-0 text-brass-500" data-id="element-136" data-mp="aabo94cg4xt9" />
                {profile.locations}
              </li>
              <li className="flex items-start gap-3 text-sm text-graphite" data-id="element-137" data-mp="19fz1j1b17etb">
                <MailIcon size={16} className="mt-0.5 shrink-0 text-brass-500" data-id="element-138" data-mp="1e78ofu57441i" />
                Inquiries reviewed personally, typically within two business
                days.
              </li>
              <li data-id="element-139" data-mp="midx269flz02">
                <a href={profile.linkedin} target="_blank" rel="noreferrer noopener" className="inline-flex items-center gap-3 font-display text-[13px] text-ink-950 transition-colors hover:text-brass-500" data-id="element-140" data-mp="mixhbtmk0zh9">
                  <LinkedinIcon size={16} className="text-brass-500" data-id="element-141" data-mp="10dzi62cjnyn7" />
                  LinkedIn Profile
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-7" data-id="element-142" data-mp="2btxx2muelewc">
            <div className="border border-stone bg-white p-8 lg:p-10" data-id="element-143" data-mp="1m73kxo1st495">
              <ContactForm data-id="element-144" data-mp="1m9gaondssiwr" />
            </div>
          </div>
        </div>
      </section>
    </>;
}